export default {
  title: {
    id: 'invoices_page_title',
    defaultMessage: 'Invoices',
  },
  invoicesNavigation: {
    id: 'invoices_page_navigation_label',
    defaultMessage: 'Invoices navigation',
  },
  invoicesPendingTab: {
    id: 'invoices_page_pending_tab',
    defaultMessage: 'Pending invoices',
  },
  invoicesWalletTab: {
    id: 'invoices_page_wallet_tab',
    defaultMessage: 'Your wallet',
  },
  invoicesWalletTabLoading: {
    id: 'seller-invoices-your_wallet-fetching_data',
    defaultMessage: 'We are fetching your data',
  },
  invoicesInvoicesTab: {
    id: 'invoices_page_invoices_tab',
    defaultMessage: 'Past invoices',
  },
  invoicesInvoicesTabLoading: {
    id: 'past_invoices_page_loading_screen_sentence',
    defaultMessage: 'Your invoices are loading',
  },
  invoicesCommercialGestureTab: {
    id: 'invoices_page_commercial_gesture_tab',
    defaultMessage: 'Goodwill gestures',
  },
  invoicesCommercialGestureTabLoading: {
    id: 'invoices_page_goodwill_gesture_tab_loading_screen_sentence',
    defaultMessage: 'Your goodwill gestures are loading',
  },
  invoicesCompensationTab: {
    id: 'invoices_page_compensation_tab',
    defaultMessage: 'Seller compensation',
  },
  invoicesCompensationTabLoading: {
    id: 'seller_compensations_page_loading_screen_sentence',
    defaultMessage: 'Your compensations are loading',
  },
  FinancialReportTab: {
    id: 'invoices_page.financial_report_tab',
    defaultMessage: 'Financial report',
  },
  FinancialReportTabLoading: {
    id: 'invoices_page.financial_report_tab.loading',
    defaultMessage: 'Your financial report is loading',
  },
  salesTab: {
    id: 'invoices_page.tabs.sales',
    defaultMessage: 'Sales',
  },
  tradeInTab: {
    id: 'invoices_page.tabs.trade_in',
    defaultMessage: 'Trade In',
  },
  tabLoading: {
    id: 'invoices_page.tabs.loading',
    defaultMessage: 'Your data is loading',
  },
  dailyPayoutsTab: {
    id: 'bo_seller.invoices_page.tabs.daily_payouts',
    defaultMessage: 'Daily payouts',
  },
}
